<div class="modal-header">
    <h3 class="modal-title text-uppercase">Agenda</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="fas fa-times"></i>
    </button>
</div>
<div class="modal-body" detect-scroll (onScroll)="loadData($event)" [bottomOffset]="200" [topOffset]="200" *ngIf="circle">
    <app-events [circle]="circle" [scrollEvent]="scrollEvent" (onNavigationStart)="bsModalRef.hide()"></app-events>
</div>
